import { useAddReferralCode, useDevice } from '../../hooks';
import { Button, Modal } from '../ui';
import './AddReferralModal.css';

export function AddReferralModal(props: { isOpen: boolean; onClose: () => void }) {
   const { isOpen, onClose } = props;
   const { isMobile } = useDevice();
   const { addReferredByForm, isLoading, submitAddReferredBy } = useAddReferralCode(onClose);

   return (
      <Modal
         className="add-referral-modal"
         onClose={onClose}
         active={isOpen}
         darkBackground>
         <div className="flex flex-col gap-4 items-center">
            <div className="flex flex-col items-center gap-2">
               <img
                  src="/assets/icons/referral-icon.svg"
                  alt=""
                  className="share-icon"
                  width={isMobile ? 70 : 80}
               />
               <div className="flex flex-col items-center gap-2">
                  <h3>A friend referred you?</h3>
                  <span className="gray text-center w-80">Enter their referral code below!</span>
               </div>
            </div>

            <form
               className="box bg-gray-2 flex flex-col items-center gap-2"
               onSubmit={addReferredByForm.handleSubmit(submitAddReferredBy)}>
               <span className="small">Referral code</span>
               <div className="flex flex-col gap-2 ">
                  <input
                     type="text"
                     className=""
                     {...addReferredByForm.register('code')}
                  />
                  <Button
                     title="Save"
                     type="white-big"
                     loading={isLoading}
                     disabled={!addReferredByForm.formState.isValid || isLoading}
                  />
               </div>
            </form>
         </div>
      </Modal>
   );
}
